


(function ($) {
    $(function () {



        function openModalWithData($btn, modalId, dataObject) {
            let $modal = $('#' + modalId);
            if ($modal.length) {
                for (var key in dataObject) {
                    let data = dataObject[key].data ? dataObject[key].data : $btn.data(key);
                    if (Array.isArray(dataObject[key])) {
                        dataObject[key].forEach(function (dataElement) {
                            modalDataHandler($modal, $btn, dataElement, data);
                        });
                    } else {
                        modalDataHandler($modal, $btn, dataObject[key], data);
                    }
                }
                $modal.modal('show');
            } else {
                console.error('Modal with #' + modalId + ' was missing in the DOM')
            }
        }

        function modalDataHandler($modal, $btn, obj, data) {
            if (obj.hasOwnProperty('type') && obj.hasOwnProperty('selector')) {
                let $field = $modal.find(obj.selector);
                if (data) {
                    if ($field.length) {
                        if (obj.type === 'value') {
                            $field.val(data);
                        } else if (obj.type === 'text') {
                            $field.text(data);
                        } else {
                            console.log('Data `type` in data array does not support. Support only: value, text. Your type: `' + dataObject[key].type + '`');
                        }
                    } else {
                        console.log('Field with selector `' + obj.selector + '` does not exist in modal');
                    }
                }
            }
        }

        const initFreeModal = () => {
            $('body').on('click', '.js-modal-free-download', function (e) {
                e.preventDefault();
                let $this = $(this);
                let modalId = 'modal-' + $this.data('modal');
                let submit_f = false;

                let data = {
                    title: {
                        type: "text",
                        selector: ".js-file-title"
                    },
                    source: {
                        type: "value",
                        selector: ".js-file-source"
                    },
                    fileName: {
                        type: "value",
                        selector: ".js-file-name"
                    },
                    id: {
                        type: "value",
                        selector: ".js-file-id"
                    }
                }

                jQuery('#form-free-download').find('#document_name').val(jQuery(this).data('title'));

                if (modalId === 'modal-free-download') {
                    $('#form-free-download .form-group').css({ opacity: 1 });
                    $('#form-free-download .form-row').css({ opacity: 1 });
                    $('#form-free-download .form-check').css({ opacity: 1 });
                    $('#form-free-download .form-actions').css({ opacity: 1 });
                    $('#form-free-download').show();
                    $('.returned-download').hide();
                    if (getCookie('file_cookie_2')) {
                        let cookieData = JSON.parse(getCookie('file_cookie_2'));
                        data['firstname'] = { type: "value", selector: "#field-fd-firstname", data: cookieData["first-name"] }
                        data['lastname'] = { type: "value", selector: "#field-fd-lastname", data: cookieData["last-name"] }
                        data['email'] = { type: "value", selector: "#field-fd-email", data: cookieData["email"] }
                        data['phone'] = { type: "value", selector: "#field-fd-phone", data: cookieData["phone"] }
                        data['company'] = { type: "value", selector: "#field-fd-company", data: cookieData["company"] }
                        $('#form-free-download .form-group').css({ opacity: 0 });
                        $('#form-free-download .form-row').css({ opacity: 0 });
                        $('#form-free-download .form-check').css({ opacity: 0 });
                        $('#form-free-download .form-actions').css({ opacity: 0 });
                        submit_f = true;
                    }
                }

                openModalWithData($this, modalId, data);
                if (submit_f) $('#form-free-download').submit();
            });


            $('body').on('click', '.js-modal-free-download', function (e) {
                e.preventDefault();
                let $btn = $(this);
                let articleId = $btn.data('id');
                let articleType = $btn.data('type');

                let $modal = $('#modal-' + $(this).data('modal'));

                $modal.find('.js-article-id').val(articleId);
                $modal.find('.js-article-type').val(articleType);

                $modal.modal('show');
            });

            $('body').on('click', '.js-modal-free-download-articles', function (e) {

                e.preventDefault();
                let $this = $(this);
                let modalId = 'modal-' + $this.data('modal');
                let submit_f = false;

                let data = {
                    category: {
                        type: "text",
                        selector: ".js-article-category"
                    },
                    title: {
                        type: "text",
                        selector: ".js-article-title"
                    },
                    type: {
                        type: "value",
                        selector: ".js-article-type"
                    },
                    id: {
                        type: "value",
                        selector: ".js-article-id"
                    }
                }

                jQuery('#form-free-download').find('#document_name').val(jQuery(this).data('title'));

                if (modalId === 'modal-free-download-articles') {
                    $('#form-free-download .form-group').css({ opacity: 1 });
                    $('#form-free-download .form-row').css({ opacity: 1 });
                    $('#form-free-download .form-check').css({ opacity: 1 });
                    $('#form-free-download .form-actions').css({ opacity: 1 });
                    $('#form-free-download').show();
                    $('.returned-download').hide();
                    if (getCookie('file_cookie_2')) {
                        let cookieData = JSON.parse(getCookie('file_cookie_2'));
                        data['firstname'] = { type: "value", selector: "#field-fd-firstname", data: cookieData["first-name"] }
                        data['lastname'] = { type: "value", selector: "#field-fd-lastname", data: cookieData["last-name"] }
                        data['email'] = { type: "value", selector: "#field-fd-email", data: cookieData["email"] }
                        data['phone'] = { type: "value", selector: "#field-fd-phone", data: cookieData["phone"] }
                        data['company'] = { type: "value", selector: "#field-fd-company", data: cookieData["company"] }
                        $('#form-free-download .form-group').css({ opacity: 0 });
                        $('#form-free-download .form-row').css({ opacity: 0 });
                        $('#form-free-download .form-check').css({ opacity: 0 });
                        $('#form-free-download .form-actions').css({ opacity: 0 });
                        submit_f = true;
                    }
                }

                openModalWithData($this, modalId, data);
                if (submit_f) $('#form-free-download').submit();
            });

        }

        const init = () => {
            console.log("free-modal-------------------js");

            initFreeModal()
        }

        init();
    });
})(jQuery, window, document);
